import { render, staticRenderFns } from "./UserBill.vue?vue&type=template&id=bd0a031c&"
import script from "./UserBill.vue?vue&type=script&lang=js&"
export * from "./UserBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports